module.exports = __webpack_public_path__ + "img/horizontal_3_4_8003.c97ca871.png";